export const areAddressesEqual = (a, b) => a.toLowerCase() === b.toLowerCase();
